import moduleDrilling from "../../store/moduleDrilling.js";
import sideView from "./components/sideView.vue";
import service from "./coreBarrelService.js";

export default {
  components: {
    sideView
  },
  data() {
    return {
      selectedMainProjectId: null,
      sidebarActive: false,
      sidebarData: {},
      model: []
    };
  },
  mounted() {
    this.$refs.listCard.refreshcard();
  },
  created() {
    if (!moduleDrilling.isRegistered) {
      this.$store.registerModule("drilling", moduleDrilling);
      moduleDrilling.isRegistered = true;
    }
  },
  methods: {
    addItem() {
      this.sidebarData = {};
      this.toggleSidebar(true);
    },
    editItem(item) {
      this.sidebarData = item;
      this.toggleSidebar(true);
    },
    toggleSidebar(val = false) {
      this.sidebarActive = val;
    },
    onUpdated() {
      this.$notifySaveSuccess();
      this.toggleSidebar(false);
      this.$refs.listCard.refreshcard();
    },

    onInserted() {
      this.$notifySaveSuccess();
      this.toggleSidebar(false);
      this.$refs.listCard.refreshcard();
    },
  
    getData() {
      service.fetchAll(this)
        .then((response) => {
          this.model = response.data.model;
        })
        .finally(() => {
          this.$refs.listCard.removeRefreshAnimation();
        });
    },

    openDeleteConfirm(id) {
      this.$deleteConfirmation({
        text: this.$t('Drilling.CoreBarrels.ConfirmDelete'),
        accept: () => this.deleteItem(id)
      });
    },

    deleteItem(id) {
      this.$vs.loading();
      service.delete(this, id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Drilling.CoreBarrels.DeletedConfirmation"));
        })
        .finally(() => {
          this.$vs.loading.close();
          this.$refs.listCard.refreshcard();
        })
        .catch((error) => {
          if (error.response.status === 409) {
            this.$refs.listCard.refreshcard();
          }
        });
    }
  }
};
